import React, { useState, useEffect, useRef } from 'react';
import 'react-alice-carousel/lib/alice-carousel.css';
import Availability from './ProgressComponents/Availability';
import PortalButton from '../components/Button';
import Review from './ProgressComponents/Review';
import Qualifications from './ProgressComponents/Qualifications';
import PersonalInformation from './ProgressComponents/PersonalInformation';
import WorkExperience from './ProgressComponents/WorkExperience';
import Agreement from './ProgressComponents/Agreement';
import { postApplicant } from '../api/postApplicant';
import ApplicationSuccessful from './ProgressComponents/ApplicationSuccessful';
import { postUserProfile } from '../api/me';
import { useAuth } from '../context/AuthContext';

function Apply() {
  const topRef = useRef();
  const { user, setUser, refreshApplicantStatus } = useAuth();
  const qualificationsRef = useRef();
  const personalInformationRef = useRef();
  const workExperienceRef = useRef();
  const availabilityRef = useRef();
  const agreementRef = useRef();
  const [newApplicant, setNewApplicant] = useState({
    qualifications: {
      has_license: null,
      authorized_to_work: null,
      can_pickup: null,
      has_washer_dryer: null,
      understands_labels: null,
      can_iron_airdry: null,
      can_lift_40lbs: null,
      felony_conviction: null,
      has_smartphone: null,
      no_smoke: null,
    },
    personalInformation: {
      address_line_1: '',
      address_line_2: '',
      city: '',
      dob: '',
      firstName: '',
      lastName: '',
      phone_number: '',
      postal_code: '',
      state: '',
      referral_code: '',
    },
    workExperience: {
      previous_work_experience: '',
      prior_experience_preparation: '',
      laundry_process: '',
      order_organization: '',
      washer_dryer_info: '',
      vehicle_info: '',
    },
    availability: [
      {
        day: 'monday',
        morning: null,
        afternoon: null,
        evening: null,
        none: null,
      },
      {
        day: 'tuesday',
        morning: null,
        afternoon: null,
        evening: null,
        none: null,
      },
      {
        day: 'wednesday',
        morning: null,
        afternoon: null,
        evening: null,
        none: null,
      },
      {
        day: 'thursday',
        morning: null,
        afternoon: null,
        evening: null,
        none: null,
      },
      {
        day: 'friday',
        morning: null,
        afternoon: null,
        evening: null,
        none: null,
      },
      {
        day: 'saturday',
        morning: null,
        afternoon: null,
        evening: null,
        none: null,
      },
      {
        day: 'sunday',
        morning: null,
        afternoon: null,
        evening: null,
        none: null,
      },
    ],
    agreements: {
      nda_exposure: null,
      nda_good_faith: null,
      nda_confidentiality: null,
      nda_noncompete: null,
      application_certification: null,
    },
  });
  const [selected, setselected] = useState(1);
  const [nextButton, setNextButton] = useState({
    text: 'Next - Personal Information',
    disabled: false,
  });
  const statusSwitch = () => {
    switch (selected) {
      case 1:
        return 'Qualifications';
        break;
      case 2:
        return 'Personal Information';
        break;
      case 3:
        return 'Work Experience & Knowledge';
        break;
      case 4:
        return 'Availability';
        break;
      case 5:
        return 'Agreement';
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (selected === 1) {
      setNextButton({
        text: 'Next - Personal Information',
        disabled: false,
      });
    } else if (selected === 2) {
      setNextButton({
        text: 'Next - Work Experience & Knowledge',
        disabled: false,
      });
    } else if (selected === 3) {
      setNextButton({
        text: 'Next - Availability',
        disabled: false,
      });
    } else if (selected === 4) {
      setNextButton({
        text: 'Next - Review',
        disabled: false,
      });
    } else if (selected === 5) {
      setNextButton({
        text: 'Submit',
        disabled: false,
      });
    }
  }, [selected]);
  const onStepChange = (step) => {
    if (step === 1) {
      if (qualificationsRef.current) {
        const isValid = qualificationsRef.current.validateForm();
        if (!isValid) {
          return;
        }
        setselected(2);
      }
    } else if (step === 2) {
      if (personalInformationRef.current) {
        const isValid = personalInformationRef.current.validateForm();
        if (!isValid) {
          return;
        }
        setselected(3);
      }
    } else if (step === 3) {
      if (workExperienceRef.current) {
        const isValid = workExperienceRef.current.validateForm();
        if (!isValid) {
          return;
        }
        setselected(4);
      }
    } else if (step === 4) {
      if (availabilityRef.current) {
        const isValid = availabilityRef.current.validateForm();
        if (!isValid) {
          return;
        }
      }
      setselected(5);
    } else if (step === 5) {
      if (agreementRef.current) {
        const isValid = agreementRef.current.validateForm();
        if (!isValid) {
          return;
        } else {
          const response = postApplicant(newApplicant, user);
          response.then(async (res) => {
            await postUserProfile({ applied: true }, user.id).then(
              async (response) => {
                setUser({ ...response });
                await refreshApplicantStatus();
              }
            );
            console.log('✅ Applicant submitted:', res);
            setselected(6);
            return;
          });
        }
      }
    }
  };
  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [selected]);
  return (
    <>
      <div className="grid grid-cols-12 gap-6 border-b pb-2 border-slate-300">
        <div className="flex flex-col col-span-full xl:col-span-4 bg-white rounded-sm">
          <div className="flex flex-row">
            <h4
              className="text-portal-600 text-2xl font-semibold mr-10"
              ref={topRef}>
              Apply
            </h4>
          </div>
        </div>
        <div className="flex flex-col col-span-full xl:col-span-8 bg-white  "></div>
      </div>
      <div className="flex justify-center max-w-[800px] mx-auto mt-8">
        <div className="p-3 sm:p-6 w-full">
          {selected < 6 && (
            <div className="">
              <span className="bg-blue-600 px-10 text-white py-3 rounded-full text-sm text-center">
                {statusSwitch()}
              </span>
            </div>
          )}
          {selected < 6 && (
            <div className="relative mt-10 ">
              <div
                className="absolute left-0  w-full h-5 bg-progress-100  rounded-full "
                aria-hidden="true"></div>
              <ul className="relative flex justify-between w-full text-sm text-semibold">
                <li className=" cursor-pointer w-3/12">
                  <div className="flex relative h-10  justify-start">
                    <span
                      className={
                        'flex items-center justify-center w-5 h-5 mb-5 rounded-full text-xs font-semibold  text-slate-500 ' +
                        (selected >= 1 ? 'bg-progress-300' : 'bg-progress-600')
                      }></span>
                  </div>
                  <div className=" relative justify-start hidden md:flex">
                    <span className={selected === 1 ? 'font-semibold' : ''}>
                      Qualifications
                    </span>
                  </div>
                </li>
                <li className=" cursor-pointer w-5/12">
                  <div className="flex relative h-10  justify-center">
                    <span
                      className={
                        'flex items-center justify-center w-5 h-5 mb-5 rounded-full text-xs font-semibold  text-slate-500 ' +
                        (selected >= 2 ? 'bg-progress-300' : 'bg-progress-600')
                      }></span>
                  </div>
                  <div
                    className=" relative justify-center hidden md:flex"
                    onClick={() => setselected(2)}>
                    <span
                      className={
                        'text-center ' + (selected === 2 ? 'font-semibold' : '')
                      }>
                      Personal Information
                    </span>
                  </div>
                </li>
                <li className=" cursor-pointer w-5/12">
                  <div className="flex relative h-10  justify-center">
                    <span
                      className={
                        'flex items-center justify-center w-5 h-5 mb-5 rounded-full text-xs font-semibold  text-slate-500 ' +
                        (selected >= 3 ? 'bg-progress-300' : 'bg-progress-600')
                      }></span>
                  </div>
                  <div className=" relative justify-center hidden md:flex">
                    <span
                      className={
                        'text-center ' + (selected === 3 ? 'font-semibold' : '')
                      }>
                      Work Experience & Knowledge
                    </span>
                  </div>
                </li>
                <li className=" cursor-pointer w-5/12">
                  <div className="flex relative h-10  justify-center">
                    <span
                      className={
                        'flex items-center justify-center w-5 h-5 mb-5 rounded-full text-xs font-semibold  text-slate-500 ' +
                        (selected >= 4 ? 'bg-progress-300' : 'bg-progress-600')
                      }></span>
                  </div>
                  <div className=" relative justify-center hidden md:flex">
                    <span className={selected === 4 ? 'font-semibold' : ''}>
                      Availability
                    </span>
                  </div>
                </li>
                <li className=" cursor-pointer w-3/12">
                  <div className="flex relative h-10  justify-end">
                    <span
                      className={
                        'flex items-center justify-center w-5 h-5 mb-5 rounded-full text-xs font-semibold  text-slate-500 ' +
                        (selected >= 5 ? 'bg-progress-300' : 'bg-progress-600')
                      }></span>
                  </div>
                  <div className=" relative justify-end hidden md:flex">
                    <span className={selected === 5 ? 'font-semibold' : ''}>
                      Agreement
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          )}
          <div
            className={
              'relative mt-4 sm:mt-10  ' + (selected === 1 ? 'block' : 'hidden')
            }>
            <div className="h-auto">
              <div className="mt-6">
                <h1 className="my-4 text-xl text-portal-600 font-medium">
                  Qualifications
                </h1>
              </div>
              <div>
                <Qualifications
                  newApplicant={newApplicant}
                  setNewApplicant={setNewApplicant}
                  ref={qualificationsRef}
                />
              </div>
            </div>
          </div>
          <div
            className={
              'relative mt-4 sm:mt-10  ' + (selected === 2 ? 'block' : 'hidden')
            }>
            <div className="h-auto">
              <PersonalInformation
                newApplicant={newApplicant}
                setNewApplicant={setNewApplicant}
                ref={personalInformationRef}
              />
            </div>
          </div>
          <div
            className={
              'relative mt-4 sm:mt-10  ' + (selected === 3 ? 'block' : 'hidden')
            }>
            <div className="h-auto">
              <WorkExperience
                newApplicant={newApplicant}
                setNewApplicant={setNewApplicant}
                ref={workExperienceRef}
              />
            </div>
          </div>
          <div
            className={
              'relative mt-4 sm:mt-10  ' + (selected === 4 ? 'block' : 'hidden')
            }>
            <Availability
              newApplicant={newApplicant}
              setNewApplicant={setNewApplicant}
              ref={availabilityRef}
            />
          </div>
          <div
            className={
              'relative mt-4 sm:mt-10  ' + (selected === 5 ? 'block' : 'hidden')
            }>
            <div>
              <Agreement
                newApplicant={newApplicant}
                setNewApplicant={setNewApplicant}
                ref={agreementRef}
              />
            </div>
          </div>
          <div
            className={
              'relative mt-4 sm:mt-10  ' + (selected === 6 ? 'block' : 'hidden')
            }>
            <div>
              <ApplicationSuccessful />
            </div>
          </div>

          {selected < 6 && (
            <div className="grid gap-1 md:grid-cols-2 mt-10 ">
              {selected > 1 ? (
                <PortalButton
                  variant="secondary"
                  text="Previous Step"
                  classes="px-10"
                  onClick={() => setselected(selected - 1)}
                />
              ) : (
                <span></span>
              )}
              <PortalButton
                variant="primary"
                text={nextButton.text}
                classes="px-10"
                onClick={() => onStepChange(selected)}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Apply;
